<template>
  <v-text-field
    v-model="searchText"
    class="feature-search"
    :placeholder="t('common.concepts.searchPlaceholder')"
    hide-details
    density="comfortable"
    variant="solo"
    clearable
    prepend-inner-icon="mdi-magnify"
    @click:clear="searchText = ''"></v-text-field>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { useI18n } from 'vue-i18n'

import FiltersStore from '@/stores/FiltersStore.ts'

const { searchText } = storeToRefs(FiltersStore())
const { t } = useI18n()
</script>

<style lang="scss" scoped>
.feature-search::v-deep(.v-field.v-field--variant-solo) {
  border-radius: 10px;
  box-shadow: none;
  background-color: rgb(var(--v-theme-surface-light));
}
</style>
